import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56VBatterieOm({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v-batterie-om" w={65.617} h={65.619} className={className}>
      <g transform="translate(-38 -39.112)">
        <g>
          <defs>
            <rect
              id={`batteria56vbatterieom_${idVariant}_SVGID_1_`}
              x="38"
              y="39.112"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56vbatterieom_${idVariant}_SVGID_2_`}>
            <use xlinkHref={`#batteria56vbatterieom_${idVariant}_SVGID_1_`} overflow="visible" />
          </clipPath>
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M71.587,104.73c17.69,0,32.03-14.34,32.03-32.031
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C39.558,90.391,53.897,104.73,71.587,104.73"
          />
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M70.03,103.174c17.691,0,32.031-14.342,32.031-32.031
      		c0-17.69-14.34-32.031-32.031-32.031C52.34,39.112,38,53.453,38,71.143C38,88.832,52.34,103.174,70.03,103.174"
          />
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M51.678,55.94h-0.577c-1.127,0-2.254-0.012-3.381,0.004
      		c-1.178,0.017-1.839,0.704-1.839,1.884c-0.001,9.017-0.001,18.032,0,27.047c0,1.205,0.672,1.871,1.892,1.871
      		c5.957,0.002,11.914,0.002,17.871,0c1.24,0,1.896-0.664,1.896-1.914c0.001-8.982,0.001-17.967,0-26.951
      		c0-1.27-0.654-1.932-1.929-1.939c-1.111-0.007-2.222,0-3.332-0.003c-0.17,0-0.339-0.018-0.537-0.027c0-0.758,0.004-1.464,0-2.171
      		c-0.004-0.69-0.314-1.019-0.993-1.02c-2.689-0.006-5.377-0.006-8.066,0c-0.683,0.001-0.998,0.326-1.003,1.013
      		C51.674,54.441,51.678,55.147,51.678,55.94 M50.149,54.421c0-0.346-0.009-0.617,0.002-0.89c0.049-1.282,1.033-2.32,2.313-2.333
      		c2.834-0.03,5.669-0.031,8.503,0c1.3,0.015,2.284,1.083,2.306,2.386c0.005,0.256,0.001,0.514,0.001,0.837
      		c0.799,0,1.567,0.007,2.335-0.002c0.813-0.008,1.567,0.171,2.213,0.687c0.848,0.676,1.253,1.562,1.252,2.648
      		c-0.004,4.961-0.002,9.921-0.002,14.882c0,4.057,0.001,8.115,0,12.174c0,2.121-1.347,3.467-3.473,3.469
      		c-5.926,0.002-11.853,0.002-17.779,0c-2.122-0.002-3.471-1.354-3.471-3.471c-0.001-8.971-0.001-17.942,0-26.912
      		c0-2.126,1.329-3.457,3.468-3.475C48.572,54.417,49.326,54.421,50.149,54.421"
          />
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M78.252,55.942c-1.359,0-2.646-0.01-3.934,0.002
      		c-1.186,0.011-1.863,0.693-1.863,1.86c0,9.032,0,18.065,0,27.096c0,1.15,0.678,1.846,1.82,1.846c6.005,0.004,12.01,0.004,18.016,0
      		c1.145,0,1.823-0.691,1.823-1.842c0.001-9.031,0.001-18.064,0-27.096c0-1.174-0.668-1.851-1.856-1.864
      		c-1.127-0.014-2.254-0.002-3.381-0.004c-0.172-0.001-0.344-0.016-0.56-0.024c0-0.742,0.002-1.446-0.001-2.151
      		c-0.003-0.72-0.311-1.043-1.018-1.044c-2.672-0.005-5.346-0.004-8.018,0c-0.713,0.001-1.023,0.32-1.027,1.038
      		C78.25,54.463,78.252,55.168,78.252,55.942 M89.849,54.424c0.862,0,1.681-0.011,2.499,0.003c1.402,0.023,2.441,0.655,3.017,1.942
      		c0.179,0.397,0.271,0.869,0.271,1.308c0.016,9.115,0.015,18.231,0.009,27.346c-0.001,1.816-1.384,3.242-3.198,3.248
      		c-6.104,0.018-12.208,0.018-18.311,0c-1.818-0.006-3.208-1.426-3.209-3.24c-0.006-9.115-0.006-18.231,0-27.346
      		c0.002-1.773,1.278-3.135,3.051-3.238c0.895-0.054,1.796-0.01,2.744-0.01c0-0.321-0.004-0.574,0.002-0.828
      		c0.029-1.358,1.033-2.406,2.382-2.415c2.786-0.021,5.573-0.02,8.358,0c1.353,0.009,2.367,1.062,2.386,2.408
      		C89.852,53.858,89.849,54.112,89.849,54.424"
          />
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#FFFFFF"
            d="M65.961,58.188H47.475v7.646h18.486V58.188z M65.966,67.459H47.471v7.64h18.495
      		V67.459z M47.453,84.377H65.95v-7.643H47.453V84.377z M51.678,55.94c0-0.793-0.004-1.5,0.001-2.206
      		c0.006-0.687,0.321-1.012,1.004-1.014c2.688-0.005,5.377-0.005,8.066,0.001c0.678,0.001,0.988,0.33,0.992,1.02
      		c0.004,0.706,0.001,1.412,0.001,2.172c0.198,0.01,0.367,0.025,0.536,0.026c1.111,0.002,2.222-0.004,3.333,0.003
      		c1.274,0.008,1.929,0.67,1.929,1.939c0,8.983,0,17.968,0,26.953c0,1.248-0.656,1.914-1.897,1.914
      		c-5.957,0.002-11.914,0.002-17.871,0c-1.22,0-1.892-0.668-1.892-1.873c-0.001-9.016-0.001-18.032,0-27.047
      		c0-1.181,0.662-1.866,1.84-1.884c1.127-0.016,2.254-0.004,3.381-0.004H51.678z"
          />
          <path
            clipPath={`url(#batteria56vbatterieom_${idVariant}_SVGID_2_)`}
            fill="#FFFFFF"
            d="M74.047,65.837h18.468v-7.671H74.047V65.837z M92.517,67.448H74.052v7.679
      		h18.465V67.448z M92.516,76.727H74.053v7.676h18.463V76.727z M78.253,55.941c0-0.772-0.003-1.478,0.001-2.183
      		c0.004-0.718,0.314-1.037,1.027-1.038c2.672-0.004,5.346-0.004,8.018,0c0.707,0.001,1.015,0.325,1.018,1.045
      		c0.002,0.704,0,1.409,0,2.149c0.217,0.011,0.389,0.024,0.561,0.024c1.127,0.002,2.254-0.009,3.381,0.005
      		c1.189,0.014,1.855,0.691,1.855,1.865c0.002,9.032,0.002,18.064,0,27.095c0,1.15-0.679,1.842-1.822,1.842
      		c-6.006,0.002-12.01,0.004-18.016,0c-1.142-0.002-1.82-0.695-1.82-1.846c-0.002-9.033-0.002-18.064,0-27.096
      		c0-1.167,0.679-1.851,1.863-1.86C75.605,55.932,76.893,55.941,78.253,55.941"
          />
        </g>
        <path
          fill="#FFFFFF"
          d="M49.006,82.85h15.408v-4.605H49.006V82.85z M47.453,76.734H65.95v7.645H47.453V76.734z"
        />
        <path
          fill="#FFFFFF"
          d="M64.43,68.986H49.007v4.586H64.43V68.986z M65.966,75.1H47.471v-7.641h18.495V75.1z"
        />
        <path
          fill="#FFFFFF"
          d="M49.006,64.301h15.409v-4.605H49.006V64.301z M65.962,65.833H47.476v-7.645h18.486V65.833z"
        />
        <path
          fill="#FFFFFF"
          d="M75.564,82.852h15.424v-4.59H75.564V82.852z M92.516,84.402H74.053v-7.676h18.463V84.402z"
        />
        <path
          fill="#FFFFFF"
          d="M91.005,68.986H75.581v4.586h15.424V68.986z M92.518,75.127H74.052v-7.679h18.466V75.127z"
        />
        <path
          fill="#FFFFFF"
          d="M91.005,59.713H75.581v4.588h15.424V59.713z M74.046,58.167h18.468v7.671H74.046V58.167z"
        />
        <rect x="49.006" y="78.244" fill="#EE7203" width="15.408" height="4.605" />
        <rect x="49.007" y="68.986" fill="#EE7203" width="15.423" height="4.586" />
        <rect x="49.006" y="59.697" fill="#EE7203" width="15.409" height="4.605" />
        <rect x="75.564" y="78.262" fill="#EE7203" width="15.424" height="4.59" />
        <rect x="75.581" y="68.986" fill="#EE7203" width="15.424" height="4.586" />
        <rect x="75.581" y="59.713" fill="#EE7203" width="15.424" height="4.588" />
      </g>
    </IconBase>
  )
}

export default Batteria56VBatterieOm
